<template>
  <i class="review-status" :class="reviewStatusRender"></i>
</template>

<script>
import { DataType, Tool } from '@/util'
const tool = new Tool()
export default {
  name: 'arb-review-status-icon',
  props: {
    keys: {
      type: [String, Array]
    },
    reviewData: {
      type: [Array, Object]
    }
  },
  computed: {
    reviewStatusRender () {
      let reviewStatusClass = ''
      let keys = this.keys
      const reviewStatusData = this.reviewData
      if (typeof keys === 'string') {
        keys = [keys]
      }

      if (keys instanceof Array) {
        let hasAccepted = false
        let hasRejected = false
        let hasOthers = false

        for (const key of keys) {
          let reviewStatus = null

          if (tool.isNotNull(reviewStatusData)) {
            reviewStatus = reviewStatusData[key]
          }

          switch (reviewStatus) {
            case DataType.ReviewStatusEnum.VERIFY.value:
              hasAccepted = true
              break
            case DataType.ReviewStatusEnum.CORRECT.value:
              hasRejected = true
              break
            case DataType.ReviewStatusEnum.NOT_VERIFY.value:
            default:
              hasOthers = true
              break
          }
        }

        if (hasOthers) {
          if (hasAccepted || hasRejected) {
            reviewStatusClass = 'fad fa-exclamation-circle text-warning'
          } else {
            reviewStatusClass = 'fad fa-question-circle text-grey'
          }
        } else {
          if (hasAccepted) {
            reviewStatusClass = 'fad fa-check-circle text-success'
          }
          if (hasRejected) {
            reviewStatusClass = 'fad fa-times-circle text-danger'
          }
        }
      }

      return reviewStatusClass
    }
  }
}
</script>
<style scoped>
.review-status {
  font-size: 15px !important;
}
</style>
